import { render, staticRenderFns } from "./repairStatus.vue?vue&type=template&id=fcd2510c&scoped=true"
import script from "./repairStatus.vue?vue&type=script&lang=js"
export * from "./repairStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcd2510c",
  null
  
)

export default component.exports